import styled from 'styled-components';

export const FooterContainer = styled.footer`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 140px;
  background-color: #171717;
  color: #c3c3c3;
  font-size: 48px;
  font-weight: 400;
  gap: 150px;
  
  a {
    font-size: 16px;
    font-style: normal;
    font-weight: 275;
    line-height: 24px;
  }

  a {
    color: #f16024;
    text-decoration-line: none;
  }

  @media (max-width: 768px) {
    height: auto;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 30px;
    padding: 40px 10%;
  }
`;
